import { Controller } from "@hotwired/stimulus"
import Uppy from "@uppy/core"
import Dashboard from "@uppy/dashboard"
import ActiveStorageUpload from "@/src/uppy_activestorage_plugin"

import "@uppy/core/css/style.css"
import "@uppy/dashboard/css/style.css"

// Connects to data-controller="uppy-upload"
//
// Usage:
//   <div data-controller="uppy-upload"
//        data-uppy-upload-field-name-value="quest[images][]"
//        data-uppy-upload-max-file-size-value="20"
//        data-uppy-upload-allowed-types-value="image/jpeg,image/png,image/gif,image/webp"
//        data-uppy-upload-max-files-value="10">
//     <button type="button" data-uppy-upload-target="trigger">Upload images</button>
//     <div data-uppy-upload-target="previews"></div>
//   </div>
export default class extends Controller {
  static targets = ["trigger", "previews"]
  static values = {
    fieldName: String,
    maxFileSize: { type: Number, default: 20 },
    allowedTypes: { type: String, default: "image/*" },
    maxFiles: { type: Number, default: 10 },
  }

  connect() {
    const directUploadUrl = document.querySelector('meta[name="direct-upload-url"]')?.content
    if (!directUploadUrl) return

    this.uppy = new Uppy({
      autoProceed: true,
      restrictions: {
        maxFileSize: this.maxFileSizeValue * 1024 * 1024,
        allowedFileTypes: this.allowedTypesValue.split(",").map(t => t.trim()),
        maxNumberOfFiles: this.maxFilesValue,
      },
    })

    this.uppy.use(ActiveStorageUpload, {
      directUploadUrl: directUploadUrl,
    })

    this.uppy.use(Dashboard, {
      trigger: this.triggerTarget,
      inline: false,
      closeAfterFinish: true,
      showProgressDetails: true,
      proudlyDisplayPoweredByUppy: false,
      theme: "light",
      note: `Up to ${this.maxFilesValue} files, ${this.maxFileSizeValue} MB each`,
    })

    this.uppy.on("complete", (result) => {
      result.successful.forEach((file) => {
        this.appendHiddenInput(file.response.signed_id)
        this.appendPreview(file)
      })
      this.uppy.clear()
    })
  }

  disconnect() {
    if (this.uppy) {
      this.uppy.destroy()
    }
  }

  appendHiddenInput(signedId) {
    const input = document.createElement("input")
    input.type = "hidden"
    input.name = this.fieldNameValue
    input.value = signedId
    this.element.appendChild(input)
  }

  appendPreview(file) {
    if (!this.hasPreviewsTarget) return

    const wrapper = document.createElement("div")
    wrapper.className = "relative group bg-gray-50 rounded-lg overflow-hidden"

    if (file.preview) {
      const img = document.createElement("img")
      img.src = file.preview
      img.className = "w-full h-32 object-cover"
      wrapper.appendChild(img)
    }

    const info = document.createElement("div")
    info.className = "p-2"
    info.innerHTML = `<p class="text-xs text-gray-700 truncate">${file.name}</p>
                      <p class="text-xs text-green-600">Uploaded</p>`
    wrapper.appendChild(info)

    this.previewsTarget.appendChild(wrapper)
  }
}
